
import {defineComponent, PropType} from 'vue';
import MovieGridItem from "@/components/MovieGridItem.vue";
import iMovie from "@/interfaces/iMovie";

import 'vue3-carousel/dist/carousel.css';
// eslint-disable-next-line
// @ts-ignore
import {Carousel, Slide, Navigation} from 'vue3-carousel';


export default defineComponent({
  name: "MoviesCarousel",
  components: {MovieGridItem, Carousel, Slide, Navigation},
  emits: ['onOpenModal'],
  props: {
    sectionTitle: {
      type: String,
      required: true,
      default: ''
    },
    movies: {
      type: Object as PropType<iMovie>,
      required: false
    }
  },
  setup(props, {emit}) {
    const openModal = (movieId: number): void => {
      emit('onOpenModal', movieId);
    }

    const carouselSettings = {
      itemsToShow: 1,
      snapAlign: 'center',
      wrapAround: true
    }

    const carouselBreakpoints = {
      768: {
        itemsToShow: 3,
        snapAlign: 'center',
      },
      992: {
        itemsToShow: 3.5,
        snapAlign: 'start',
      },
      1600: {
        itemsToShow: 5.5,
        snapAlign: 'start',
      }
    }
    return {
      openModal,
      carouselSettings,
      carouselBreakpoints
    }
  }
})
